<template>
  <b-container class="my-5">
    <b-row>
      <b-col xl="12">
        <b-card no-body>
          <h3 class="card-header bg-white">Nuevo consultorio</h3>
          <b-card-body>
            <b-form @submit="onSubmit" @reset="onReset">
              <b-form-row>
                <b-form-group
                  class="col-md-12"
                  label="Dirección"
                  label-for="address">
                  <b-input-group>
                    <template v-slot:prepend>
                      <b-input-group-text >
                        <font-awesome-icon :icon="['fas','map-marker-alt']"/>
                      </b-input-group-text>
                    </template>
                    <b-form-input
                      id="address"
                      v-model="form.data.addressString"
                      placeholder="Ingrese una dirección"
                      trim />
                  </b-input-group>
                </b-form-group>
              </b-form-row>
              <b-form-row>
                <b-form-group
                  class="col-md-6"
                  label="Calle"
                  label-for="street">
                  <b-input-group>
                    <template v-slot:prepend>
                      <b-input-group-text >
                        <font-awesome-icon :icon="['fas','road']"/>
                      </b-input-group-text>
                    </template>
                    <b-form-input
                      id="street"
                      v-model="form.data.street"
                      placeholder="Calle"
                      trim />
                  </b-input-group>
                </b-form-group>
                <b-form-group
                  class="col-md-3"
                  label="Int./Piso/Consultorio(Opc)"
                  label-for="street">
                  <b-input-group>
                    <template v-slot:prepend>
                      <b-input-group-text >
                        <font-awesome-icon :icon="['fas','building']"/>
                      </b-input-group-text>
                    </template>
                    <b-form-input
                      id="street"
                      v-model="form.data.address.addressLine1"
                      placeholder="Calle"
                      trim />
                  </b-input-group>
                </b-form-group>
                <b-form-group
                  class="col-md-3"
                  label="Colonia"
                  label-for="districtOrCounty">
                  <b-input-group>
                    <template v-slot:prepend>
                      <b-input-group-text >
                        <font-awesome-icon :icon="['fas','building']"/>
                      </b-input-group-text>
                    </template>
                    <b-form-input
                      id="street"
                      v-model="form.data.address.districtOrCounty"
                      placeholder="Colonia"
                      trim />
                  </b-input-group>
                </b-form-group>
              </b-form-row>
              <b-form-row>
                <b-form-group
                  class="col-md-3"
                  label="Ciudad"
                  label-for="city">
                  <b-input-group>
                    <template v-slot:prepend>
                      <b-input-group-text >
                        <font-awesome-icon :icon="['fas','city']"/>
                      </b-input-group-text>
                    </template>
                    <b-form-input
                      id="city"
                      v-model="form.data.address.city"
                      placeholder="Ciudad"
                      trim />
                  </b-input-group>
                </b-form-group>
                <b-form-group
                  class="col-md-3"
                  label="Estado"
                  label-for="stateOrRegion">
                  <b-input-group>
                    <template v-slot:prepend>
                      <b-input-group-text >
                        <font-awesome-icon :icon="['fas','user']"/>
                      </b-input-group-text>
                    </template>
                    <b-form-input
                      id="stateOrRegion"
                      v-model="form.data.address.stateOrRegion"
                      placeholder="Estado"
                      trim />
                  </b-input-group>
                </b-form-group>
                <b-form-group
                  class="col-md-3"
                  label="País"
                  label-for="country">
                  <b-input-group>
                    <template v-slot:prepend>
                      <b-input-group-text >
                        <font-awesome-icon :icon="['fas','flag']"/>
                      </b-input-group-text>
                    </template>
                    <b-form-input
                      id="country"
                      v-model="form.data.address.country"
                      placeholder="País"
                      trim />
                  </b-input-group>
                </b-form-group>
                <b-form-group
                  class="col-md-3"
                  label="Código postal"
                  label-for="postalCode">
                  <b-input-group>
                    <template v-slot:prepend>
                      <b-input-group-text >
                        <font-awesome-icon :icon="['fas','mail-bulk']"/>
                      </b-input-group-text>
                    </template>
                    <b-form-input
                      id="street"
                      v-model="form.data.address.postalCode"
                      placeholder="Código postal"
                      trim />
                  </b-input-group>
                </b-form-group>
              </b-form-row>
              <b-form-row>
                <b-form-group
                  class="col-md-3"
                  label="Edificio"
                  label-for="city">
                  <b-input-group>
                    <template v-slot:prepend>
                      <b-input-group-text >
                        <font-awesome-icon :icon="['fas','city']"/>
                      </b-input-group-text>
                    </template>
                    <b-form-input
                      id="city"
                      v-model="form.data.address.city"
                      placeholder="Edificio"
                      trim />
                  </b-input-group>
                </b-form-group>
                <b-form-group
                  class="col-md-3"
                  label="Precio"
                  label-for="price">
                  <b-input-group>
                    <template v-slot:prepend>
                      <b-input-group-text >
                        <font-awesome-icon :icon="['fas','dollar-sign']"/>
                      </b-input-group-text>
                    </template>
                    <b-form-input
                      id="price"
                      type="number"
                      v-model="form.data.price"
                      placeholder="Precio"
                      trim />
                  </b-input-group>
                </b-form-group>
                <b-form-group
                  class="col-md-3"
                  label="Email"
                  label-for="email">
                  <b-input-group>
                    <template v-slot:prepend>
                      <b-input-group-text >
                        <font-awesome-icon :icon="['fas','at']"/>
                      </b-input-group-text>
                    </template>
                    <b-form-input
                      id="country"
                      type="email"
                      v-model="form.data.email"
                      placeholder="Email"
                      trim />
                  </b-input-group>
                </b-form-group>
                <b-form-group
                  class="col-md-3"
                  label="Teléfono"
                  label-for="phone">
                  <b-input-group>
                    <template v-slot:prepend>
                      <b-input-group-text >
                        <font-awesome-icon :icon="['fas','phone']"/>
                      </b-input-group-text>
                    </template>
                    <b-form-input
                      id="phone"
                      v-model="form.data.phone"
                      placeholder="Teléfono"
                      trim />
                  </b-input-group>
                </b-form-group>
              </b-form-row>
              <b-form-row>
                <b-form-group
                  class="col-md-6"
                  label="Especialidades"
                  label-for="specialities">
                  <b-input-group>
                    <template v-slot:prepend>
                      <b-input-group-text >
                        <font-awesome-icon :icon="['fas','city']"/>
                      </b-input-group-text>
                    </template>
                    <b-form-select
                      :options="specialities.data"
                      id="specialities"
                      v-model="form.data.specialities"
                      placeholder="Especialidades"
                      trim />
                  </b-input-group>
                </b-form-group>
              </b-form-row>
              <b-button type="reset" class="mr-2" variant="secondary">Regresar</b-button>
              <b-button type="submit" variant="success">Guardar</b-button>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col xl="12">
        <adsense
          ad-slot="9585150092"
          ad-format="auto"
          ad-client="ca-pub-1844310477126911"
          ad-style="display:block">
        </adsense>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Adsense from '@/components/Adsense'

export default {
  components: { Adsense },
  name: 'About',
  data () {
    return {
      form: {
        data: {
          addressString: null,
          venue: null,
          address: {
            addressLine1: null,
            addressLine2: null,
            districtOrCounty: null,
            countryCode: null,
            postalCode: null,
            city: null
          },
          price: 0,
          email: null,
          phone: null,
          specialities: [],
          appointmentDuration: null,
          allowWebAppointments: false
        }
      },
      specialities: {
        data: [
          { value: 'Oncologia', text: 'Oncólogo' },
          { value: 'pediatria', text: 'Pediatra' }
        ],
        total: 0
      }
    }
  },
  mounted: async function () {

  },
  methods: {
    onSubmit: async function (event) {
      event.preventDefault()
      try {
        await this.$http.post('/offices', this.form.data)
        this.$router.push('/offices')
      } catch (error) {
        const err = error.response.data.errors[0]
        // const err = error
        this.$bvToast.toast(err.message, {
          title: 'Error creando consultorio',
          autoHideDelay: 5000
        })
      }
    },
    onReset () {}
  }
}
</script>
